import { NumberPatternType } from '@dreryk/react-common';

import { serviceSettingsTranslationKeys } from '../../../translations';
import { AdvancePaymentsSettingsFormController } from '../AdvancePaymentsSettingsForm.types';

import { StyledFullRefundThresholdInHoursField } from './FullRefundThresholdInHoursField.styled';

const t = serviceSettingsTranslationKeys.advancePayments.form.refundTypeField;

export const FULL_REFUND_THRESHOLD_IN_HOURS_DEFAULT_VALUE = 24;
const MAX = 336;
const MIN = 0;

export type FullRefundThresholdInHoursFieldFieldValue = number;

type FullRefundThresholdInHoursFieldProps = Pick<AdvancePaymentsSettingsFormController, 'register' | 'watch'>;

export const FullRefundThresholdInHoursField = (props: FullRefundThresholdInHoursFieldProps): JSX.Element => {
   const { refundType } = props.watch(['refundType']);
   const disabled = refundType !== 'FULL_REFUND';

   return (
      <StyledFullRefundThresholdInHoursField
         compact
         inlineError
         testId={'fullRefundThresholdInHours'}
         min={MIN}
         max={MAX}
         defaultValue={FULL_REFUND_THRESHOLD_IN_HOURS_DEFAULT_VALUE}
         pattern={NumberPatternType.POSITIVE_INTEGER}
         disabled={disabled}
         controller={props.register('fullRefundThresholdInHours', {
            required: !disabled,
            max: disabled ? undefined : { value: MAX, message: t.fullRefund.validate.max },
         })}
      />
   );
};
